<template>
  <div class="pageStyle">
    <!-- 全屏loading遮罩 -->
    <div class="loading-mask" v-show="isLoading">
      <div class="loading-content">
        <div class="loading-spinner"></div>
        <div class="loading-text">页面加载中...</div>
      </div>
    </div>
    <div class="content">
      <div
        class="item"
        :class="{ 'slide-in-item': startAnimation }"
        :style="startAnimation ? { animationDelay: 0.2 + 's' } : {}"
      >
        <div class="top">
          <div>企业卓越绩效管理</div>
          <div>卓越绩效领航 · 夯实管理根基 · 赋能企业进阶</div>
        </div>
        <div class="bottom">
          <div class="bottom-item">
            <div class="title">核心优势</div>
            <div class="txt moreTag">
              <div>
                <img
                  src="https://static.xchengtech.cn/539406ede726401c82202fe415f980c3.png"
                  alt=""
                />
                标准框架支撑
              </div>
              <div>
                <img
                  src="https://static.xchengtech.cn/539406ede726401c82202fe415f980c3.png"
                  alt=""
                />
                专家服务团队
              </div>
              <div>
                <img
                  src="https://static.xchengtech.cn/539406ede726401c82202fe415f980c3.png"
                  alt=""
                />
                全维度系统评估
              </div>
              <div>
                <img
                  src="https://static.xchengtech.cn/539406ede726401c82202fe415f980c3.png"
                  alt=""
                />
                践成果赋能
              </div>
            </div>
          </div>
        </div>
        <div
          class="btn"
          @click="toUrl(platformConfig.jxtUrls.qyzyjxgl)"
        >
          <span>立即查看</span>
        </div>
      </div>
      <div
        class="item"
        :class="{ 'slide-in-item': startAnimation }"
        :style="startAnimation ? { animationDelay: 0.2 + 's' } : {}"
      >
        <div class="top">
          <div>财政预算绩效管理</div>
          <div>赋能第三方机构参与预算绩效管理实践</div>
        </div>
        <div class="bottom">
          <div class="bottom-item">
            <div class="title">核心优势</div>
            <div class="txt">
              <div>
                <img
                  src="https://static.xchengtech.cn/539406ede726401c82202fe415f980c3.png"
                  alt=""
                />
                直连政府（财政 /
                预算部门）资源，搭建合作平台助力会员精准匹配委托方项目
              </div>
              <div>
                <img
                  src="https://static.xchengtech.cn/539406ede726401c82202fe415f980c3.png"
                  alt=""
                />
                辅导项目承接与交付，解读最新财政绩效评价政策，确保会员服务符合政府规范要求。
              </div>
            </div>
          </div>
        </div>
        <div
          class="btn"
          @click="toUrl(platformConfig.jxtUrls.czyjsjxgl)"
        >
          <span>立即查看</span>
        </div>
      </div>
    </div>
    <!-- 关于我们 -->
    <div class="aboutUs" v-if="platformConfig.aboutUs">
      <span
        @click="toAboutUs"
      >
        <img
          src="https://static.xchengtech.cn/416fcc5039fb4a9b8383d98b92067318.png"
          alt=""
        />
        关于我们
      </span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Icon, Toast } from "vant";
import { getPlatformTypeConfig, getPlatformCodeByDomain } from "@/config/platform.js";
import { mapGetters } from "vuex";

Vue.use(Icon);
Vue.use(Toast);

export default {
  name: 'Jxt',
  created() {
    this.startAnimation = true;
    this.initPlatform();
  },
  data() {
    return {
      isLoading: false,
      startAnimation: false,
      channelId: this.$route.query.channelId,
      platformCode: '',
      platformConfig: {}
    };
  },
  computed: {
    ...mapGetters(["Login"]),
  },
  methods: {
    initPlatform() {
      this.platformCode = getPlatformCodeByDomain();
      // 从 store 获取 platformType
      const platformType = this.$store.state.platformType || 'portal';
      this.platformConfig = getPlatformTypeConfig(platformType);
    },
    toPage(name, query) {
      this.$router.push({ path: "/" + name, query: query });
    },
    toAboutUs() {
      if (this.platformConfig.aboutUs) {
        this.toPage('previewImage', {
          type: this.platformConfig.aboutUs.type,
          title: this.platformConfig.aboutUs.title,
        });
      }
    },
    toUrl(url) {
      if (url) {
        const toast = Toast.loading({
          duration: 0,
          forbidClick: true,
          message: "加载中",
          overlay: true,
        });
        setTimeout(() => {
          toast.close();
          window.location.href = url + '?channelId=' + this.channelId;
        }, 300);
      } else {
        Toast("敬请期待");
      }
    },
  },
};
</script>

<style scoped>
/* 图标地址：https://www.iconfont.cn/collections/detail?spm=a313x.collections_index.i1.d9df05512.58b93a814eYZym&cid=53415 */

/* 全屏loading样式 */
.loading-mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid #f3f3f3;
  border-top: 4px solid #2770f1;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 15px;
}

.loading-text {
  color: #2770f1;
  font-size: 14px;
  font-weight: 500;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* 卡片滑入动画 */
.slide-in-item {
  opacity: 0;
  transform: translateX(-100px);
  animation: slideInLeft 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
}

@keyframes slideInLeft {
  0% {
    opacity: 0;
    transform: translateX(-100px) scale(0.9);
  }
  60% {
    opacity: 0.8;
    transform: translateX(10px) scale(1.02);
  }
  100% {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}
.pageStyle {
  position: relative;
  font-family: "黑体";
  padding-top: 47vw;
  background: url("https://static.xchengtech.cn/e7c110ccee264b998acf1527915e5e8c.jpg");
  background-repeat: no-repeat;
  background-size: 100% auto;
  width: 100%;
  background-color: #caf0fd;
  min-height: 100vh;
  font-size: 3.6vw;
  padding-bottom: 17vw;
}
.content {
  display: grid;
  gap: 4vw;
  padding: 4vw;
}
.content .item {
  display: grid;
  gap: 2vw;
  border-radius: 12px;
  padding: 5vw 4vw;
  background-color: white;
  box-shadow: 0 4px 12px #c7e3fa;
}
.content .item .top {
  display: grid;
  gap: 2vw;
}

.content .item .top div:nth-of-type(1) {
  display: flex;
  align-items: center;
  gap: 2vw;
  font-weight: 600;
  font-size: 4.8vw;
  color: #2a4067;
}

.content .item .top div:nth-of-type(2) {
  color: #aab3c4;
  font-size: 4vw;
}
.content .item .bottom {
  display: grid;
  gap: 4vw;
  margin-top: 2vw;
}
.content .item .bottom .bottom-item {
  transition: all 0.3s ease;
}
.content .item .bottom .bottom-item .title {
  font-size: 4.2vw;
  font-weight: 600;
  color: #2a4067;
  margin-bottom: 2vw;
  display: flex;
  align-items: center;
  gap: 1.5vw;
}
.content .item .bottom .bottom-item .txt {
  font-size: 3.6vw;
  color: #495057;
  line-height: 7vw;
  display: grid;
  gap: 2vw;
}
.content .item .bottom .bottom-item .txt div {
  display: flex;
  align-items: flex-start;
  gap: 2vw;
}
.content .item .bottom .bottom-item:nth-child(3) .txt {
  display: grid;
  gap: 1.5vw;
}
.content .item .bottom .bottom-item .txt img {
  display: block;
  height: 4vw;
  margin-top: 1.4vw;
}
.content .item .btn {
  margin-top: 2vw;
  width: 100%;
  background-color: #3776ff;
  color: white;
  border-radius: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 4vw;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 3vw 0;
  box-shadow: 0 4px 12px rgba(55, 118, 255, 0.3);
  font-weight: 600;
}
.content .item .moreTag {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
}
.aboutUs {
  padding-top: 4vw;
  display: flex;
  justify-content: center;
  font-size: 4vw;
  display: flex;
  color: #2a4067;
  align-items: center;
}
.aboutUs span {
  display: flex;
  align-items: center;
  gap: 1vw;
  border: 1px solid #3776ff;
  background-color: white;
  padding: 2vw 4vw;
  color: #3776ff;
  font-size: 4vw;
  border-radius: 36px;
  box-shadow: 0 4px 15px rgba(55, 118, 255, 0.2);
}
.aboutUs img {
  display: block;
  height: 5vw;
}
</style>



// WEBPACK FOOTER //
// src/components/Jxt.vue